module.exports = "/images/scan-qr-interaction.png?16477f4c78f1f7637bf6eaefa84583b9";